import React, { createRef } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import {
  Form,
  FormGroup,
  Input,
  Label,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  CardFooter,
  Row,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  UncontrolledTooltip,
  InputGroupAddon,
  InputGroup,
  Container,
} from "reactstrap";

import {
  PanelHeader,
  Button,
  // CardCategory
} from "components";

import { locationActions, traitActions, marketingEmailActions } from "_actions";
import { history, isValidEmail, isValidUrl, atLeastOneLetter } from "_helpers"
import { isPossiblePhoneNumber } from 'react-phone-number-input'
import PhoneInput from 'react-phone-number-input'
import NotificationAlert from "components/react-notification-alert/NotificationAlert";
import SweetAlert from "components/react-bootstrap-sweetalert/SweetAlert.jsx";

import mobileImage from "assets/img/img-livenyte/mobileImage.jpg";
import mobileBusinessLaunchImage from "assets/img/img-livenyte/mobileBusinessLaunchImage.jpg";

import { config } from '_constants';
import { FeaturingCelebsSmall, LiveNyteLaunchPartnerTerms } from "components";

// import creatorLanding from "assets/img/img-livenyte/creatorLanding.mp4";
import AutoPlaySilentVideo from "components/AutoPlaySilentVideo/AutoPlaySilentVideo.js"
import landingPlaceholder from "assets/img/img-livenyte/creatorLandingScreen.jpg";
import botd from '@fingerprintjs/botd';
import Select from "react-select";
import appStore from "assets/img/img-livenyte/appStore.png";
import playStore from "assets/img/img-livenyte/getItOnGooglePlay.png";

import { IndexNavbar } from "components/Navbars/IndexNavbar.jsx";
import AuthFooter from "components/Footers/AuthFooter.jsx";
import { borderTop } from '@mui/system';

import livenyteLogoBG from "assets/img/img-livenyte/livenyte-logo-with-background.png";
import Tabs from 'antd/es/tabs';

import TalentLaunchForm from "views/LandingPages/components/TalentLaunchForm.js";
import BusinessLaunchForm from 'views/LandingPages/components/BusinessLaunchForm.js';
import TalentPartnerForm from 'views/LandingPages/components/TalentPartnerForm.js';
import BusinessPartnerForm from 'views/LandingPages/components/BusinessPartnerForm.js';

const { TabPane } = Tabs;

const queryString = require('query-string');

class SDLandingPage extends React.Component {

  constructor(props) {
    super(props);

    console.log("Dashboard props", props)

    if (props.location.search && props.location.search !== "") {
      let query = queryString.parse(props.location.search);
      // console.log("query", query)
      console.log("ad_id", query.ad_id)
      localStorage.setItem('ad_id', query.ad_id)
    } else {
      // localStorage.removeItem('ad_id')
    }
    this.sectionRef = createRef(); // create the ref
    this.partnerWithUsRef = createRef()

    const whatIsLiveNyteStartingIdx = 0
    this.state = {
      isVideoLoaded: false,
      name: '',
      name2: '',
      contactName: '',
      instagram: '',
      instagram2: '',
      youtube: '',
      description: '',
      phone: '',
      contactPhone: '',
      email: '',
      email2: '',
      whyPartner: '',
      address: '',
      submitted: false,
      submitted2: false,
      isBot: false,
      botChecked: false,
      notificationMessage: [], // [ { message: '', color: ''}]
      alert: null,
      promptPartnerWithUsSection: false,
      partnerWithUsVisible: false,

      nameState: 'has-danger',
      name2State: 'has-danger',
      contactNameState: 'has-danger',

      descriptionState: 'has-danger',
      emailState: 'has-danger',
      email2State: 'has-danger',

      phoneState: 'has-danger',
      contactPhoneState: 'has-danger',
      traitState: 'has-danger',
      trait2State: 'has-danger',

      youtubeState: 'has-success',
      businessUrlState: 'has-danger',
      whyPartnerState: 'has-danger',
      addressState: 'has-danger',
      launchTermsModal: false,
      talentMode: null,
      activeTab: '0',
    };
    this.handleButtonClick = this.handleButtonClick.bind(this)
    this.getIntroCard = this.getIntroCard.bind(this)
    this.onLoadedData = this.onLoadedData.bind(this)
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleLaunchSubmit = this.handleLaunchSubmit.bind(this);
    this.testYoutube = this.testYoutube.bind(this)
    this.notify = this.notify.bind(this)
    this.goToForm = this.goToForm.bind(this)
    this.completeSubmission = this.completeSubmission.bind(this)
    this.completeLaunchSubmission = this.completeLaunchSubmission.bind(this)
    this.openPartnerWithUsForm = this.openPartnerWithUsForm.bind(this)
    this.toggleLaunchTermsModal = this.toggleLaunchTermsModal.bind(this);
    this.setTalentMode = this.setTalentMode.bind(this)
    this.checkBusinessWebsiteUrl = this.checkBusinessWebsiteUrl.bind(this);
    this.hideAlert = this.hideAlert.bind(this)
    this.checkContactName = this.checkContactName.bind(this)
    this.checkContactPhoneNumber = this.checkContactPhoneNumber.bind(this)
    this.checkAddress = this.checkAddress.bind(this)

    this.checkName2 = this.checkName2.bind(this)
    this.checkEmail2 = this.checkEmail2.bind(this)
    this.selectTrait2 = this.selectTrait2.bind(this)
    this.checkPhoneNumber = this.checkPhoneNumber.bind(this);


    this.checkName = this.checkName2.bind(this)
    this.checkEmail = this.checkEmail2.bind(this)
    this.selectTrait = this.selectTrait2.bind(this)

    this.checkUrl = this.checkUrl.bind(this)
    this.checkDescription = this.checkDescription.bind(this)
    this.checkWhyPartner = this.checkWhyPartner.bind(this)
  }




  componentDidMount() {
    this.props.dispatch(traitActions.getSpecialistTraits());
    this.props.dispatch(traitActions.getBusinessTraits())
    this.props.dispatch(locationActions.getCurrentLocation((success, pos) => {
      console.log("my location is", pos)
    }))
    // ReactPixel.pageView();
    window.scrollTo(0, 0);
    this.setupVideo()

    botd.load().then(botdInstance => {
      const result = botdInstance.detect(); // 🔹 No `.then()` here!
      console.log("BotD result:", result);

      this.setState({
        isBot: result.bot,
        botChecked: true,
      });
    }).catch(err => {
      console.error("BotD load or detection failed:", err);
      this.setState({ botChecked: true }); // Fallback: allow submission
    });

  }

  componentWillUnmount() {
    document.body.removeEventListener('mousedown', () => this.handleVideo('mousedown'));
  }

  toggleLaunchTermsModal() {
    this.setState({
      launchTermsModal: !this.state.launchTermsModal
    });
  }

  tabChange(e) {
    console.log("tabChange", e)
    this.setState({
      activeTab: e
    });
  }

  goToForm = () => {
    if (this.sectionRef.current) {
      this.sectionRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }

  goToPartnerWithUs = () => {
    if (this.partnerWithUsRef.current) {
      this.partnerWithUsRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }

  handleButtonClick(state) {
    window.open(`/?openSignUpModal=${state}`, '_blank', 'noopener,noreferrer')
  }

  componentWillUnmount() {
    const { intervalId, intervalId2 } = this.state
    if (intervalId) {
      clearInterval(intervalId)
    }
    if (intervalId2) {
      clearInterval(intervalId2)
    }
  }

  setTalentMode(newValue) {
    this.setState({
      talentMode: newValue,
      activeTab: newValue === true ? '0' : '1'
    }, () => {
      if (this.sectionRef.current) {
        this.sectionRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    })
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  notify() {
    const { notificationMessage } = this.state
    // console.log("notify", notificationMessage)
    if (notificationMessage.length === 0) {
      return;
    }
    let type;
    switch (notificationMessage[0].color) {
      case 1:
        type = "success";
        break;
      case 2:
        type = "danger";
        break;

      default:
        break;
    }
    let options = {};
    options = {
      place: "tr",
      message: (
        <div>
          <div>
            {notificationMessage[0].message}
          </div>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 7
    };
    console.log("refs", this.refs)
    if (this.refs.hasOwnProperty('notificationAlert')) {
      let nm = [...notificationMessage]
      nm.splice(0, 1)
      this.setState({ notificationMessage: nm })
      this.refs.notificationAlert.notificationAlert(options);
    }
  }

  handleLaunchSubmit(e) {
    console.log("handleLaunchSubmit", this.state)
    const { name2State, email2State, trait2State, botChecked, isBot, talentMode, addressState, phoneState, businessUrlState, contactNameState, contactPhoneState } = this.state


    if (!botChecked) {
      alert("Checking for bots, please wait...");
      return;
    }

    if (isBot) {
      alert("Bot detected. Submission blocked.");
      return;
    }

    if (this.state.submitted2) {
      const message = "You've already sent us a submission."
      this.setState({ notificationMessage: [...this.state.notificationMessage, { message: message, color: 2 }] })
    }

    if (talentMode === true) {
      if (name2State === 'has-success' &&
        email2State === 'has-success' &&
        trait2State === 'has-success'
      ) {
        this.confirmLaunchDetailsAlert()
      } else {
        const message = "One or more fields has invalid input."
        this.setState({ notificationMessage: [...this.state.notificationMessage, { message: message, color: 2 }] })
      }
    } else {
      if (name2State === 'has-success' &&
        email2State === 'has-success' &&
        trait2State === 'has-success' &&
        addressState === 'has-success' &&
        phoneState === 'has-success' &&
        businessUrlState === 'has-success' &&
        contactNameState === 'has-success' &&
        contactPhoneState === 'has-success'
      ) {
        this.confirmLaunchDetailsAlert()
      } else {
        const message = "One or more fields has invalid input."
        this.setState({ notificationMessage: [...this.state.notificationMessage, { message: message, color: 2 }] })
      }
    }


  }



  handleSubmit(e) {
    console.log("handle submit", this.state)
    const { talentMode, nameState, descriptionState, emailState, phoneState, youtubeState, traitState, whyPartnerState, botChecked, isBot } = this.state


    if (!botChecked) {
      alert("Checking for bots, please wait...");
      return;
    }

    if (isBot) {
      alert("Bot detected. Submission blocked.");
      return;
    }

    if (this.state.submitted) {
      const message = "You've already sent us a submission."
      this.setState({ notificationMessage: [...this.state.notificationMessage, { message: message, color: 2 }] })
    }

    if (talentMode) {
      if (nameState === 'has-success' &&
        descriptionState === 'has-success' &&
        whyPartnerState === 'has-success' &&
        emailState === 'has-success' &&
        phoneState === 'has-success' &&
        traitState === 'has-success' &&
        youtubeState === 'has-success') {
        this.confirmDetailsAlert()
      } else {
        const message = "One or more fields has invalid input."
        this.setState({ notificationMessage: [...this.state.notificationMessage, { message: message, color: 2 }] })
      }
    } else {
      if (descriptionState === 'has-success' &&
        whyPartnerState === 'has-success') {
        this.confirmDetailsAlert()
      } else {
        const message = "One or more fields has invalid input."
        this.setState({ notificationMessage: [...this.state.notificationMessage, { message: message, color: 2 }] })
      }
    }


  }

  handleVideo(fired) {
    console.log("was fired", fired)
    const videoElement = document.getElementById('home_video');
    if (videoElement && videoElement.playing) {
      // video is already playing so do nothing
    }
    else if (videoElement) {
      videoElement.play();
    } else {
      console.log("Can't find video")
    }
  }

  setupVideo() {
    // document.body.addEventListener('click touchstart', () => this.handleVideo('click touchstart'));
    // window.addEventListener('scroll', () => this.handleVideo('scroll'));
    document.body.addEventListener('mousedown', () => this.handleVideo('mousedown'));

  }

  onLoadedData = () => {
    this.setState({
      isVideoLoaded: true
    })
  };

  testYoutube(url) {
    const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/[^\s]+$/;
    console.log("urlRegex", youtubeRegex.test(url));
    return youtubeRegex.test(url)
  }

  selectTrait(e) {
    console.log("selectTrait", e)
    // var newState = this.state
    // newState.selectedTrait = e.label === "Show All" ? null : e.label
    this.setState({ selectedTrait: e.label, selectedTraitValue: e, traitState: 'has-success' })
  }

  selectTrait2(e) {
    console.log("selectTrait", e)
    // var newState = this.state
    // newState.selectedTrait = e.label === "Show All" ? null : e.label
    this.setState({ selectedTrait2: e.label, selectedTraitValue: e, selectedTraitValue2: e, trait2State: 'has-success' })
  }

  confirmLaunchDetailsAlert() {
    const { talentMode } = this.state
    if (talentMode === true) {
      this.setState({
        alert: (
          <SweetAlert
            custom
            forceLightMode
            customIcon={livenyteLogoBG}
            title="Join the SD Launch"
            onConfirm={() => this.completeLaunchSubmission()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="success"
            confirmBtnText="Join"
            showCancel
          >
            <p className="text-center text-default">
              <span>
                Name: {this.state.name2} <br />
                Email: {this.state.email2} <br />
                Talent: {this.state.selectedTrait2} <br />
                Instagram: {this.state.instagram2}
              </span>
            </p>
          </SweetAlert>
        )
      });
    } else {
      this.setState({
        alert: (
          <SweetAlert
            custom
            forceLightMode
            customIcon={livenyteLogoBG}
            title="Join the SD Launch"
            onConfirm={() => this.completeLaunchSubmission()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="success"
            confirmBtnText="Join"
            showCancel
          >
            <p className="text-center text-default">
              <span>
                Name: {this.state.name2} <br />
                Email: {this.state.email2} <br />
                Type: {this.state.selectedTrait2} <br />
                Address: {this.state.address} <br />
                Phone: {this.state.phone} <br />
                Website: {this.state.businessUrl} <br />
                Contact Name: {this.state.contactName} <br />
                Contact Phone: {this.state.contactPhone}
              </span>
            </p>
          </SweetAlert>
        )
      });
    }

  }


  confirmDetailsAlert() {
    const { talentMode } = this.state
    if (talentMode === true) {
      this.setState({
        alert: (
          <SweetAlert
            custom
            forceLightMode
            customIcon={livenyteLogoBG}
            title="Confirm Partner Application"
            onConfirm={() => this.completeSubmission()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="default"
            confirmBtnText="Apply"
            showCancel
          >
            <p className="text-center text-default">
              <span>
                Name: {this.state.name} <br />
                Email: {this.state.email} <br />
                Talent: {this.state.selectedTrait} <br />
                Phone: {this.state.phone} <br />
                Instagram: {this.state.instagram} <br />
                YouTube: {this.state.youtube}
              </span>
            </p>
          </SweetAlert>
        )
      });
    } else {
      this.setState({
        alert: (
          <SweetAlert
            custom
            forceLightMode
            customIcon={livenyteLogoBG}
            title="Confirm Partner Application"
            onConfirm={() => this.completeSubmission()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="default"
            confirmBtnText="Apply"
            showCancel
          >
            <p className="text-center text-default">
              <span>
                Name: {this.state.name} <br />
                Email: {this.state.email} <br />
                Type: {this.state.selectedTrait} <br />
                Address: {this.state.address} <br />
                Phone: {this.state.phone} <br />
                Website: {this.state.businessUrl} <br />
                Contact Name: {this.state.contactName} <br />
                Contact Phone: {this.state.contactPhone}
              </span>
            </p>
          </SweetAlert>
        )
      });
    }

  }

  hideAlert() {
    this.setState({
      alert: null
    });
  }

  completeLaunchSubmission() {
    const { talentMode, email2, name2, selectedTrait2, instagram2, launchSubmissionSending } = this.state
    const { address, phone, businessUrl, contactName, contactPhone } = this.state
    const formId = 9
    // const formData = new FormData();
    // formData.append('mauticform[f_name1]', name2);
    // formData.append('mauticform[email]', email2);
    // formData.append('mauticform[primary_talent]', selectedTrait2);
    // formData.append('mauticform[instagram_handle]', instagram2);
    // formData.append('mauticform[formId]', formId); 

    const postData = {
      'mauticform[f_name1]': name2,
      'mauticform[email]': email2,
      'mauticform[primary_talent]': selectedTrait2,
      'mauticform[instagram_handle]': instagram2,
      'mauticform[formId]': formId
    }

    const businessFormId = 17
    const businessPostData = {
      'mauticform[f_name1]': name2,
      'mauticform[email]': email2,
      'mauticform[primary_talent]': selectedTrait2,

      'mauticform[address]': address,
      'mauticform[phone_number]': phone,
      'mauticform[website]': businessUrl,
      'mauticform[business_contact_name]': contactName,
      'mauticform[business_contact_phone_nu]': contactPhone,

      'mauticform[formId]': businessFormId
    }

    if (launchSubmissionSending) {
      return
    }

    const selectedFormId = talentMode ? formId : businessFormId
    const selectedPostData = talentMode ? postData : businessPostData

    this.props.dispatch(marketingEmailActions.submitMauticForm(selectedFormId, selectedPostData, (success, data) => {
      //isActive and email are undefined on success 
      if (success) {
        if (talentMode) {
          this.setState({
            name: name2,
            email: email2,
            instagram: instagram2,
            selectedTrait: selectedTrait2,
          }, () => {
            this.setState({
              name2: '',
              instagram2: '',
              email2: '',
              submitted2: true,
              nameState: 'has-success',
              traitState: 'has-success',
              emailState: 'has-success',
              alert: null,
              promptPartnerWithUsSection: true,
              name2State: 'has-danger',
              trait2State: 'has-danger',
              email2State: 'has-danger',
              launchSubmissionSending: false,
              alert: (
                <SweetAlert
                  success
                  forceLightMode
                  title="You're in!"
                  onConfirm={() => this.hideAlert()}
                  confirmBtnBsStyle="primary"
                  confirmBtnText="Dismiss"
                  timeout={5000}
                >
                  <p className="text-center text-default">
                    <span>
                      <span className="h4"> Welcome to the SD Launch!</span>
                    </span>
                  </p>
                </SweetAlert>
              ),
            })
          })
        } else {
          this.setState({
            name: name2,
            email: email2,
            selectedTrait: selectedTrait2,
          }, () => {
            this.setState({
              name2: '',
              email2: '',
              submitted2: true,
              nameState: 'has-success',
              traitState: 'has-success',
              emailState: 'has-success',
              alert: null,
              promptPartnerWithUsSection: true,
              name2State: 'has-danger',
              trait2State: 'has-danger',
              email2State: 'has-danger',
              launchSubmissionSending: false,
              alert: (
                <SweetAlert
                  success
                  forceLightMode
                  title="You're in!"
                  onConfirm={() => this.hideAlert()}
                  confirmBtnBsStyle="primary"
                  confirmBtnText="Dismiss"
                  timeout={5000}
                >
                  <p className="text-center text-default">
                    <span>
                      <span className="h4"> Welcome to the SD Launch!</span>
                    </span>
                  </p>
                </SweetAlert>
              ),
            })
          })
        }

      } else {
        this.setState({
          launchSubmissionSending: false
        })
        console.error('Form submission failed.', data);
      }
    }))
  }

  completeSubmission() {
    // const formData = new FormData();
    const { talentMode, name, selectedTrait, instagram, youtube, description, phone, email, whyPartner, partnerSubmissionSending } = this.state
    const { address, businessUrl, contactName, contactPhone } = this.state

    const formId = 6

    // formData.append('mauticform[f_name]', name);
    // formData.append('mauticform[email]', email);
    // formData.append('mauticform[primary_talent]', selectedTrait);
    // formData.append('mauticform[mobile_number]', phone);
    // formData.append('mauticform[instagram]', instagram);
    // formData.append('mauticform[youtube_channel_link_opti]', youtube);
    // formData.append('mauticform[about_you]', description);
    // formData.append('mauticform[why_partner_with_us]', whyPartner);

    // formData.append('mauticform[formId]', formId); // Your Mautic form ID

    const postData = {
      'mauticform[f_name]': name,
      'mauticform[email]': email,
      'mauticform[primary_talent]': selectedTrait,
      'mauticform[mobile_number]': phone,
      'mauticform[instagram]': instagram,
      'mauticform[youtube_channel_link_opti]': youtube,
      'mauticform[about_you]': description,
      'mauticform[why_partner_with_us]': whyPartner,
      'mauticform[formId]': formId,
    }

    const businessFormId = 16

    const businessPostData = {
      'mauticform[f_name1]': name,
      'mauticform[email]': email,
      'mauticform[primary_talent]': selectedTrait,
      'mauticform[address]': address,
      'mauticform[phone_number]': phone,
      'mauticform[website]': businessUrl,
      'mauticform[business_contact_name]': contactName,
      'mauticform[business_contact_phone_nu]': contactPhone,
      'mauticform[about_you]': description,
      'mauticform[why_partner]': whyPartner,


      'mauticform[formId]': businessFormId
    }

    if (partnerSubmissionSending) {
      return
    }

    const selectedFormId = talentMode ? formId : businessFormId
    const selectedPostData = talentMode ? postData : businessPostData

    this.props.dispatch(marketingEmailActions.submitMauticForm(selectedFormId, selectedPostData, (success, data) => {
      //isActive and email are undefined on success 
      if (success) {
        this.setState({
          submitted: true,
          name: '',
          instagram: '',
          youtube: '',
          description: '',
          phone: '',
          email: '',
          whyPartner: '',
          partnerSubmissionSending: false,
          alert: (
            <SweetAlert
              success
              forceLightMode
              title="Partner Application Sent"
              onConfirm={() => this.hideAlert()}
              confirmBtnBsStyle="primary"
              confirmBtnText="Close"
              timeout={5000}
            >
              <p className="text-center text-default">
                <span>
                  <span className="h4"> Your partner application was sent.</span>
                </span>
              </p>
            </SweetAlert>
          ),
          nameState: 'has-danger',
          descriptionState: 'has-danger',
          emailState: 'has-danger',
          phoneState: 'has-danger',
          youtubeState: 'has-success',
          traitState: 'has-danger',
          whyPartnerState: 'has-danger'
        })
      } else {
        this.setState({
          partnerSubmissionSending: false
        })
        console.error('Form submission failed.', data);
      }
    }))

  }

  checkDescription(e) {
    console.log("checkDescription", e)
    // var newState = this.state
    // newState['description'] = e.target.value
    // if (e.target.value === '') {
    //   newState['descriptionState'] = 'has-danger'
    // } else {
    //   newState['descriptionState'] = 'has-success'
    // }
    const description = e.target.value
    const descriptionState = description === '' || !atLeastOneLetter(description) ? 'has-danger' : 'has-success'
    this.setState({ description: description, descriptionState: descriptionState })

  }

  checkWhyPartner(e) {
    console.log("checkWhyPartner", e)
    // var newState = this.state
    // newState['description'] = e.target.value
    // if (e.target.value === '') {
    //   newState['descriptionState'] = 'has-danger'
    // } else {
    //   newState['descriptionState'] = 'has-success'
    // }
    const whyPartner = e.target.value
    const whyPartnerState = whyPartner === '' || !atLeastOneLetter(whyPartner) ? 'has-danger' : 'has-success'
    this.setState({ whyPartner: whyPartner, whyPartnerState: whyPartnerState })

  }

  checkUrl(e) {
    console.log("checkUrl", e)
    const url = e.target.value
    const urlState = this.testYoutube(url) || (url.length < 1 || url === null || url === "") ? 'has-success' : 'has-danger'
    this.setState({ youtube: url, youtubeState: urlState })
  }

  checkBusinessWebsiteUrl(e) {
    console.log("checkUrl", e)
    const url = e.target.value
    const urlState = isValidUrl(url) ? 'has-success' : 'has-danger'
    this.setState({ businessUrl: url, businessUrlState: urlState })
  }

  checkName(e) {
    //  var newState = this.state
    //  newState['eventName'] = e.target.value
    //  if (e.target.value === '') {
    //    newState['eventNameState'] = 'has-danger'
    //  } else {
    //    newState['eventNameState'] = 'has-success'
    //  }

    const name = e.target.value
    const nameState = atLeastOneLetter(name) ? 'has-success' : 'has-danger'
    this.setState({ name: name, nameState: nameState })
  }

  checkName2(e) {
    //  var newState = this.state
    //  newState['eventName'] = e.target.value
    //  if (e.target.value === '') {
    //    newState['eventNameState'] = 'has-danger'
    //  } else {
    //    newState['eventNameState'] = 'has-success'
    //  }

    const name = e.target.value
    const nameState = atLeastOneLetter(name) ? 'has-success' : 'has-danger'
    this.setState({ name2: name, name2State: nameState })
  }

  checkAddress(e) {
    //  var newState = this.state
    //  newState['eventName'] = e.target.value
    //  if (e.target.value === '') {
    //    newState['eventNameState'] = 'has-danger'
    //  } else {
    //    newState['eventNameState'] = 'has-success'
    //  }

    const address = e.target.value
    const addressState = atLeastOneLetter(address) ? 'has-success' : 'has-danger'
    this.setState({ address: address, addressState: addressState })
  }

  checkContactName(e) {
    //  var newState = this.state
    //  newState['eventName'] = e.target.value
    //  if (e.target.value === '') {
    //    newState['eventNameState'] = 'has-danger'
    //  } else {
    //    newState['eventNameState'] = 'has-success'
    //  }

    const name = e.target.value
    const nameState = atLeastOneLetter(name) ? 'has-success' : 'has-danger'
    this.setState({ contactName: name, contactNameState: nameState })
  }

  checkEmail(e) {
    //  var newState = this.state
    //  newState['eventName'] = e.target.value
    //  if (e.target.value === '') {
    //    newState['eventNameState'] = 'has-danger'
    //  } else {
    //    newState['eventNameState'] = 'has-success'
    //  }

    const email = e.target.value
    const emailState = isValidEmail(email) ? 'has-success' : 'has-danger'
    this.setState({ email: email, emailState: emailState })
  }


  checkEmail2(e) {
    //  var newState = this.state
    //  newState['eventName'] = e.target.value
    //  if (e.target.value === '') {
    //    newState['eventNameState'] = 'has-danger'
    //  } else {
    //    newState['eventNameState'] = 'has-success'
    //  }

    const email = e.target.value
    const emailState = isValidEmail(email) ? 'has-success' : 'has-danger'
    this.setState({ email2: email, email2State: emailState })
  }

  checkPhoneNumber(e) {
    const phone = e;
    this.setState({ phone: phone })
    if (isPossiblePhoneNumber(phone)) {
      this.setState({ phoneState: 'has-success' })
    } else {
      this.setState({ phoneState: 'has-danger' })
    }
  }

  checkContactPhoneNumber(e) {
    const phone = e;
    this.setState({ contactPhone: phone })
    if (isPossiblePhoneNumber(phone)) {
      this.setState({ contactPhoneState: 'has-success' })
    } else {
      this.setState({ contactPhoneState: 'has-danger' })
    }
  }

  openPartnerWithUsForm() {
    this.setState({
      partnerWithUsVisible: true,
    }, this.goToPartnerWithUs)

  }




  getIntroCard() {
    const { loggedIn, info, is_md, fanMode } = this.props
    const { selectedLiveNyteIs, talentMode } = this.state
    const user = JSON.parse(localStorage.getItem('user'));
    // const userIsAgencyAsClient = user && user.agency_as_client;
    const userIsSpecialist = loggedIn && user && user.is_specialist;
    const userIsBusiness = loggedIn && user && user.is_business;
    const userIsAgency = loggedIn && user && user.is_agency

    return (
      <div className={"pb-4 text-center"}>
        <h1 className={"display-1 mb-3 livenyte-title text-white special-underline-white glitch-text"}>
          Join the SD Launch
        </h1>
        <h2 className={"display-4 title text-white" + (is_md ? "" : "")}>
          Be part of the first wave of venues, promoters, and talent — from DJs and comedians to musicians and creators — shaping the future of live bookings in SD. Select partners will be featured in our launch events.
        </h2>
        <div className="pt-1 mt-1 text-white">
          {/* <span className={" " + (is_md ? "" : "t")} style={{fontSize: "1.13rem"}}> 
              We're looking to partner with select talent & creators. You bring the talent we bring the bookings, audience and promotion. 
              </span > */}
        </div>
        <Row className="mt-4  text-center ">
          {/* <Col xs={8} className="text-center mx-auto ">
                  <Button
                    className="mt-4 bg-gradient-livenyte"
                    color="primary"
                    size="lg"
                    style={{fontSize:"1rem"}}
                    block
                    onClick={this.goToForm}
                  >
                    Join the Launch
                  </Button>
                
                </Col> */}
          {talentMode === null ? (
            <Col md="8" xs={11} className="mx-auto text-center">
              <div className="mt-0">
                <span className="display-3 surtitle text-white livenyte-title glitch-text glitch-text-animated ">Are You A </span>
                <br />
                <div className="inline-block ">
                  <Button
                    className="mt-4"
                    color="primary"
                    outline
                    onClick={(e) => this.setTalentMode(true)}
                  >
                    <span style={{ letterSpacing: "2px", textTransform: "uppercase" }} className="display-4 text-center glitch-text glitch-text-animated glitch-text glitch-text-animated ">Talent</span>
                  </Button>

                </div>
                <div className="inline-block ml-4">
                  <Button
                    className="mt-4"
                    color="purple"
                    outline
                    onClick={(e) => this.setTalentMode(false)}
                  >
                    <span style={{ letterSpacing: "2px", textTransform: "uppercase" }} className="display-4 text-center glitch-text glitch-text-animated">Business</span>
                  </Button>

                </div>
              </div>
            </Col>
          ) : (
            <Col md="8" xs={11} className="mx-auto text-center">
              {/* <div className="mt-0">
                    <h3 className={(("surtitle glitch-text glitch-text-animated ") + (talentMode ? " text-primary " : " text-purple "))}>Joining as</h3>
                    <span className={(("display-2 surtitle livenyte-title glitch-text glitch-text-animated ") + (talentMode ? " text-primary " : " text-purple "))}>{talentMode ? "TALENT + CREATOR" : "BUSINESS"} </span>
                </div> */}
            </Col>
          )}
        </Row>

      </div>

    )
  }



  render() {
    const { selectedProductSubtype, selectedProductType, selectedLiveNyteIs, isVideoLoaded, selectedTrait, talentMode } = this.state
    const { spTraits, spSubTraits, busTraits } = this.props
    const { activeTab, } = this.state

    let traitOptions = []
    let dispSpSubTraits = []
    if (spTraits && spTraits.length > 0) {
      traitOptions = spTraits.reduce((obj, item) => {
        obj.push({ value: obj.length, label: item.trait })
        return obj
      }, [])
    }
    if (spSubTraits && spSubTraits.length > 0) {
      dispSpSubTraits = spSubTraits.filter(subTrait => subTrait.trait === selectedTrait)
        .map(subTrait => subTrait.subtrait)
    }


    const businessTraitOptions = busTraits && busTraits.reduce((obj, item) => {
      obj.push({ value: obj.length, label: item.trait })
      return obj
    }, [])



    return (
      <div>
        <IndexNavbar isDarkGlassMode={false} useNewWindowForLinks={true} />
        <div className="rna-wrapper">
          <NotificationAlert ref="notificationAlert" />
        </div>
        <div className="main-content">
          {this.notify()}
          {this.state.alert}
          <div className={this.props.is_md ? "" : ""}>
            <header className={"header-4 "}>
              <div className="header-wrapper">
                <div className="page-header header-video">
                  <div className="overlay"></div>
                  <div className="">
                    {!isVideoLoaded &&
                      <img
                        src={landingPlaceholder}
                        className=" progressiveVideo-tiny objectFitCover z98"
                        alt="thumb"
                        style={{ position: "absolute", right: "0", opacity: isVideoLoaded ? 0 : 1 }}
                      />
                    }
                    <AutoPlaySilentVideo
                      video={config.commonUrl + "/Common/creatorLandingVideo.mp4"}
                      // video={landingVideo}
                      className="test-video"
                      isVideoLoaded={isVideoLoaded}
                      onLoadedData={this.onLoadedData}
                      id="home_video"
                    />
                  </div>
                  <Container className="" style={{ paddingTop: "0" }}>
                    <Row>
                      <Col className="mx-auto px-0" lg="12">
                        <Card className=" bg-transparent-carbon card-box-shadow mb-0">
                          <CardBody>
                            {this.getIntroCard()}
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </Container>
                </div>
              </div>
            </header>
          </div>
        </div>
        {talentMode !== null &&
          <div ref={this.sectionRef}>
            <section className="pt-5 pb-6 bg-white">
              <div className="landingContainer">
                <Row>
                  {/* <Col md="3" sm={3} xs="4" className=" mx-auto">
                    <div className={activeTab === '0' ? "launchPagePinkTabs" : "launchPagePurpleTabs "}>
                      <Tabs defaultActiveKey='0' 
                        activeKey={activeTab}
                        centered
                        disabled
                        onChange={(e) => this.tabChange(e)}
                        >
                      {talentMode === true ? (
                        <TabPane tab="Talent" key="0"/>
                          ) 
                          : 
                          (
                        <TabPane tab="Businesses" key='1'/>
                          )}
                    </Tabs>
                  </div>
                </Col> */}
                  <Col md="8" sm={8} xs="11" className=" mx-auto text-center">
                    <div className="mt-0">
                      <span className={(talentMode ? "special-underline-livenyte" : "special-underline-purple")}>
                        <h3 className={(("surtitle glitch-text glitch-text-animated ") + (talentMode ? " text-primary " : " text-purple "))}>Joining as a</h3>
                        <span className={(("display-2 surtitle livenyte-title glitch-text glitch-text-animated ") + (talentMode ? " text-primary " : " text-purple "))}>{talentMode ? "TALENT + CREATOR" : "BUSINESS"} </span>
                      </span>
                    </div>
                  </Col>
                </Row>
                <Row className="row-grid align-items-center text-center" >
                  <Col md="6" xs="12" className=" mx-auto">
                    <img
                      alt="..."
                      className="img-fluid"
                      src={activeTab === '0' ? mobileImage : mobileBusinessLaunchImage}
                    />
                  </Col>
                  <Col md="6" xs="12" className=" mx-auto ">
                    <div className="pr-md-5">
                      <div className="card-pricing bg-transparent zoom-in-1 bg-dark border-0 ">
                        <div className="text-center" >
                          <span className={(("display-3 surtitle text-default livenyte-title  mb-2 glitch-text ") + (talentMode !== false ? "special-underline-livenyte" : "special-underline-purple"))}>WHAT YOU GET</span>
                          <div className='mt-3'>
                            <ul className="text-left list-unstyled mx-auto px-4">
                              <li>
                                <div className="d-flex align-items-left">
                                  <div>
                                    <div className={(("icon icon-sm icon-shape shadow rounded-circle text-white " + (talentMode !== false ? " bg-gradient-livenyte " : " bg-gradient-purple ")))}>
                                      <i className="fas fa-star" />
                                    </div>
                                  </div>
                                  <div>
                                    <h2 className="pl-4 text-default  font-weight-normal">Access to emerging talent & performers</h2>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div className="d-flex align-items-left">
                                  <div>
                                    <div className={(("icon icon-sm icon-shape shadow rounded-circle text-white " + (talentMode !== false ? " bg-gradient-livenyte " : " bg-gradient-purple ")))}>
                                      <i className="fas fa-bullhorn" />
                                    </div>
                                  </div>
                                  <div>
                                    <h2 className="pl-4 text-default  font-weight-normal">
                                      Promotional exposure through LiveNyte
                                    </h2>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div className="d-flex align-items-left">
                                  <div>
                                    <div className={(("icon icon-sm icon-shape shadow rounded-circle text-white " + (talentMode !== false ? "bg-gradient-livenyte " : " bg-gradient-purple ")))}>
                                      <i className="fas fa-calendar-check" />
                                    </div>
                                  </div>
                                  <div>
                                    <h2 className="pl-4 text-default  font-weight-normal">Easy booking tools to streamline scheduling</h2>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div className="d-flex align-items-left">
                                  <div>
                                    <div className={(("icon icon-sm icon-shape shadow rounded-circle text-white " + (talentMode !== false ? " bg-gradient-livenyte " : " bg-gradient-purple ")))}>
                                      <i className="fas fa-users" />
                                    </div>
                                  </div>
                                  <div>
                                    <h2 className="pl-4 text-default font-weight-normal">Grow your audience through co-promotion</h2>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <div className="d-flex align-items-left">
                                  <div>
                                    <div className={(("icon icon-sm icon-shape shadow rounded-circle text-white " + (talentMode !== false ? " bg-gradient-livenyte " : " bg-gradient-purple ")))}>
                                      <i className="fas fa-trophy" />
                                    </div>
                                  </div>
                                  <div>
                                    <h2 className="pl-4 text-default font-weight-normal">Perks for early partners during our launch</h2>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>

                        </div>

                      </div>

                    </div>
                  </Col>
                </Row>
              </div>
            </section>
            <FeaturingCelebsSmall useSpecialUnderLineLiveNyte={talentMode} useGlitch={true} />
            <section className="pt-5 pb-6 bg-white">
              <div className="landingContainer">
                <Row className="row-grid align-items-center"  >
                  <Col md="8" xs={11} className="mx-auto text-center">
                    <span className={(("h1 text-center surtitle livenyte-title glitch-text glitch-text-animated mb-2 ") + (talentMode !== false ? "special-underline-livenyte text-default" : "special-underline-purple text-default "))}>Join our SD Launch As A
                      {/* <h3 className={(("surtitle glitch-text glitch-text-animated ") + (talentMode ? " text-primary " : " text-purple "))}>Join our SD Launch </h3> */}
                      <h3 className={(("display-3 text-center surtitle livenyte-title mb-2 glitch-text glitch-text-animated  ") + (talentMode ? "text-primary" : "text-purple"))}>{talentMode ? "Talent + Creator" : "Business"}</h3>

                    </span>
                  </Col>
                  {/* {talentMode === null &&
                <Col md="8" xs={11} className="mx-auto text-center">
                  <div className="mt-4 mr-4">
                    <span className="display-4 surtitle text-white livenyte-title">CHOOSE</span>
                    <br/>
                    <div className="inline-block ">
                      <Button
                        className="mt-4"
                        color="primary"
                        outline
                        onClick={(e) => this.setTalentMode(true)}
                      >
                        <span style={{letterSpacing: "2px", textTransform: "uppercase"}} className="display-4 text-center livenyte-title">Talent</span>
                      </Button>
              
                    </div>
                    <div className="inline-block ml-4">
                      <Button
                        className="mt-4"
                        color="purple"
                        outline
                        onClick={(e) => this.setTalentMode(false)}
                      >
                        <span style={{letterSpacing: "2px", textTransform: "uppercase"}} className="display-4 text-center livenyte-title">Business</span>
                      </Button>
              
                    </div>
                </div>
                </Col>
                }
                {talentMode !== null && 
                <Col md="8" xs={11} className="mx-auto text-center mt-3">
                  <h3 className={(("surtitle glitch-text glitch-text-animated ") + (talentMode ? " text-primary " : " text-purple "))}>AS A</h3>
                  <span className={(("display-3 text-center surtitle livenyte-title mb-2 glitch-text glitch-text-animated ") + (talentMode ? "text-primary" : "text-purple"))}>{talentMode ? "Talent" : "Business"}</span>
                </Col>
                } */}
                  {!this.state.submitted2 && talentMode === true &&
                    <Col md="8" xs={11} className="mx-auto" >
                      <TalentLaunchForm
                        name2={this.state.name2}
                        name2State={this.state.name2State}
                        email2={this.state.email2}
                        email2State={this.state.email2State}
                        trait2State={this.state.trait2State}
                        selectedTraitValue2={this.state.selectedTraitValue2}
                        traitOptions={traitOptions}
                        instagram2={this.state.instagram2}

                        submitted2={this.state.submitted2}
                        isBot={this.state.isBot}
                        botChecked={this.state.botChecked}
                        talentMode={this.state.talentMode}

                        checkName2={this.checkName2}
                        checkEmail2={this.checkEmail2}
                        selectTrait2={this.selectTrait2}
                        handleChange={this.handleChange}
                        handleLaunchSubmit={this.handleLaunchSubmit}
                      />
                      {/* <Row className='mt-4'>
                    <Col lg="12">
                        <Label className="form-control-label">Name
                        <i className="pl-2 fas fa-info-circle surtitle-gray cursor-pointer " 
                              id="name2"
                          />
                          <UncontrolledTooltip  
                            placement="right" 
                            target="name2" 
                            delay={0}> 
                            Enter your name 
                          </UncontrolledTooltip>

                        </Label>
                        <FormGroup 
                        className={"mt-2 " + this.state.name2State}
                        >
                          <Input
                            type="text" 
                            name="name2" 
                            value={this.state.name2}
                            placeholder="Your name"
                            onBlur={e => this.checkName2(e )}
                            onChange={e => this.checkName2(e)}
                            valid={
                              this.state.name2State === "has-success"
                            }
                            invalid={
                              this.state.name2State === "has-danger"
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="12" >
                        <Label className="form-control-label">Email
                        <i className="pl-2 fas fa-info-circle surtitle-gray cursor-pointer " 
                              id="email2"
                          />
                          <UncontrolledTooltip  
                            placement="right" 
                            target="email2" 
                            delay={0}> 
                            Enter your email address.  
                          </UncontrolledTooltip>

                        </Label>
                        <FormGroup 
                        className={"mt-2 " + this.state.email2State}
                        >
                          <Input
                            type="email" 
                            name="email2" 
                            value={this.state.email2}
                            placeholder="Your email"
                            onBlur={e => this.checkEmail2(e)}
                            onChange={e => this.checkEmail2(e)}
                            valid={
                              this.state.email2State === "has-success"
                            }
                            invalid={
                              this.state.email2State === "has-danger"
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="12" >
                        <Label className="form-control-label">Primary Talent
                        <i className="pl-2 fas fa-info-circle surtitle-gray cursor-pointer " 
                              id="selectedTrait2"
                          />
                          <UncontrolledTooltip  
                            placement="right" 
                            target="selectedTrait2" 
                            delay={0}> 
                            Choose the talent that best describes the main thing you do
                          </UncontrolledTooltip>

                        </Label>
                        <FormGroup 
                        className={"mt-2 " + this.state.trait2State}
                        >
                          <Select
                            className="react-select primary wrap-cursor-pointer"
                            classNamePrefix="react-select"
                            placeholder="Choose Main Talent"
                            name="selectedTrait2"
                            value={this.state.selectedTraitValue2}
                            options={traitOptions}
                            onChange={value => this.selectTrait2(value) }
                          />
                        </FormGroup>
                      </Col>

                     
                      <Col lg="12" >
                        <FormGroup 
                        // className={this.state.nameState}
                        >
                        <Label className="form-control-label">Instagram
                        <i className="pl-2 fas fa-info-circle surtitle-gray cursor-pointer " 
                              id="instagram2"
                          />
                          <UncontrolledTooltip  
                            placement="right" 
                            target="instagram2" 
                            delay={0}> 
                            Enter your instagram handle.  
                          </UncontrolledTooltip>

                        </Label>
                          <Input
                            type="text" 
                            name="instagram2" 
                            value={this.state.instagram2}
                            placeholder="Your Instagram handle"
                            onBlur={e => this.handleChange(e)}
                            onChange={e => this.handleChange(e)}
                            // valid={
                            //   this.state.nameState === "has-success"
                            // }
                            // invalid={
                            //   this.state.nameState === "has-danger"
                            // }
                          />
                        </FormGroup>
                      </Col>
  

                      <Col xs={12} className="text-center">
                        <Button style={{fontSize:"1rem"}} disabled={this.state.submitted2 || this.state.isBot || !this.state.botChecked} color={talentMode ? "primary" : "purple"}s ize="lg" block className={talentMode ? " title bg-gradient-livenyte" : " title bg-gradient-purple"}onClick={e => this.handleLaunchSubmit(e)}>
                            {this.state.submitted2 ? 'Launch request sent' : 'Join'}
                        </Button>
                      </Col>
                  </Row> */}
                    </Col>}
                  {!this.state.submitted2 && talentMode === false &&
                    <Col md="8" xs={11} className="mx-auto" >
                      <Row className='mt-4'>
                        <BusinessLaunchForm
                          name2={this.state.name2}
                          name2State={this.state.name2State}
                          email2={this.state.email2}
                          email2State={this.state.email2State}
                          trait2State={this.state.trait2State}
                          selectedTraitValue2={this.state.selectedTraitValue2}
                          businessTraitOptions={businessTraitOptions}
                          addressState={this.state.addressState}
                          address={this.state.address}
                          phoneState={this.state.phoneState}
                          phone={this.state.phone}
                          businessUrlState={this.state.businessUrlState}
                          businessUrl={this.state.businessUrl}
                          contactNameState={this.state.contactNameState}
                          contactName={this.state.contactName}
                          contactPhoneState={this.state.contactPhoneState}
                          contactPhone={this.state.contactPhone}

                          submitted2={this.state.submitted2}
                          isBot={this.state.isBot}
                          botChecked={this.state.botChecked}
                          talentMode={this.state.talentMode}

                          checkName2={this.checkName2}
                          checkEmail2={this.checkEmail2}
                          selectTrait2={this.selectTrait2}
                          checkAddress={this.checkAddress}
                          checkPhoneNumber={this.checkPhoneNumber}
                          checkBusinessWebsiteUrl={this.checkBusinessWebsiteUrl}
                          checkContactName={this.checkContactName}
                          checkContactPhoneNumber={this.checkContactPhoneNumber}
                          handleLaunchSubmit={this.handleLaunchSubmit}
                        />
                        {/* <Col lg="12">
                        <Label className="form-control-label">Business Name
                        <i className="pl-2 fas fa-info-circle surtitle-gray cursor-pointer " 
                              id="name2"
                          />
                          <UncontrolledTooltip  
                            placement="right" 
                            target="name2" 
                            delay={0}> 
                            Enter your business's name 
                          </UncontrolledTooltip>

                        </Label>
                        <FormGroup 
                        className={"mt-2 " + this.state.name2State}
                        >
                          <Input
                            type="text" 
                            name="name2" 
                            value={this.state.name2}
                            placeholder="Your business's name"
                            onBlur={e => this.checkName2(e )}
                            onChange={e => this.checkName2(e)}
                            valid={
                              this.state.name2State === "has-success"
                            }
                            invalid={
                              this.state.name2State === "has-danger"
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="12" >
                        <Label className="form-control-label">Business Email
                        <i className="pl-2 fas fa-info-circle surtitle-gray cursor-pointer " 
                              id="email2"
                          />
                          <UncontrolledTooltip  
                            placement="right" 
                            target="email2" 
                            delay={0}> 
                            Enter your business's email address.  
                          </UncontrolledTooltip>

                        </Label>
                        <FormGroup 
                        className={"mt-2 " + this.state.email2State}
                        >
                          <Input
                            type="email" 
                            name="email2" 
                            value={this.state.email2}
                            placeholder="Your business's email"
                            onBlur={e => this.checkEmail2(e)}
                            onChange={e => this.checkEmail2(e)}
                            valid={
                              this.state.email2State === "has-success"
                            }
                            invalid={
                              this.state.email2State === "has-danger"
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="12" >
                        <Label className="form-control-label">Business Type
                        <i className="pl-2 fas fa-info-circle surtitle-gray cursor-pointer " 
                              id="selectedTrait2"
                          />
                          <UncontrolledTooltip  
                            placement="right" 
                            target="selectedTrait2" 
                            delay={0}> 
                            Choose the business type that best describes your business. 
                          </UncontrolledTooltip>

                        </Label>
                        <FormGroup 
                        className={"mt-2 " + this.state.trait2State}
                        >
                          <Select
                            className="react-select primary wrap-cursor-pointer"
                            classNamePrefix="react-select"
                            placeholder="Choose Business Type"
                            name="selectedTrait2"
                            value={this.state.selectedTraitValue2}
                            options={businessTraitOptions}
                            onChange={value => this.selectTrait2(value) }
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="12">
                        <Label className="form-control-label">Business Address
                        <i className="pl-2 fas fa-info-circle surtitle-gray cursor-pointer " 
                              id="address"
                          />
                          <UncontrolledTooltip  
                            placement="right" 
                            target="address" 
                            delay={0}> 
                            Enter your business's address
                          </UncontrolledTooltip>

                        </Label>
                        <FormGroup 
                        className={"mt-2 " + this.state.addressState}
                        >
                          <Input
                            type="text" 
                            name="address" 
                            value={this.state.address}
                            placeholder="Your business's address"
                            onBlur={e => this.checkAddress(e)}
                            onChange={e => this.checkAddress(e)}
                            valid={
                              this.state.addressState === "has-success"
                            }
                            invalid={
                              this.state.addressState === "has-danger"
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="12" >
                        <Label className="form-control-label">Business Phone Number
                        <i className="pl-2 fas fa-info-circle surtitle-gray cursor-pointer " 
                              id="phone"
                          />
                          <UncontrolledTooltip  
                            placement="right" 
                            target="phone" 
                            delay={0}> 
                            Enter your business's phone number  
                          </UncontrolledTooltip>

                        </Label>
                        <FormGroup 
                        className={"mt-2 " + this.state.phoneState}
                        >
                          <div className='phone-input '>
                            <PhoneInput
                              placeholder="Your business's phone number"
                              value={this.state.phone}
                              defaultCountry="US"
                                onChange={e => this.checkPhoneNumber(e)}/>
                          </div>
                        </FormGroup>
                      </Col>

                      <Col lg="12" >

                        <Label className="form-control-label ">Business Website
                        <i className="pl-2 fas fa-info-circle surtitle-gray cursor-pointer " 
                              id="businessUrl"
                          />
                          <UncontrolledTooltip  
                            placement="right" 
                            target="businessUrl" 
                            delay={0}> 
                            Enter your business's website.  
                          </UncontrolledTooltip>

                        </Label>
                        <FormGroup 
                        className={"mt-2 " + this.state.businessUrlState}
                        >
                          <Input
                            type="url" 
                            name="businessUrl" 
                            className='bg-transparent surtitle-light-gray'
                            value={this.state.businessUrl}
                            placeholder="Your business's website"
                            onBlur={e => this.checkBusinessWebsiteUrl(e)}
                            onChange={e => this.checkBusinessWebsiteUrl(e)}
                            valid={
                              this.state.businessUrlState === "has-success"
                            }
                            invalid={
                              this.state.businessUrlState === "has-danger"
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="12">
                        <Label className="form-control-label">Contact's Name
                        <i className="pl-2 fas fa-info-circle surtitle-gray cursor-pointer " 
                              id="contactName"
                          />
                          <UncontrolledTooltip  
                            placement="right" 
                            target="contactName" 
                            delay={0}> 
                            Enter the name of your business's contact. 
                          </UncontrolledTooltip>

                        </Label>
                        <FormGroup 
                        className={"mt-2 " + this.state.contactNameState}
                        >
                          <Input
                            type="text" 
                            name="contactName" 
                            value={this.state.contactName}
                            placeholder="Your contact's name"
                            onBlur={e => this.checkContactName(e )}
                            onChange={e => this.checkContactName(e)}
                            valid={
                              this.state.contactNameState === "has-success"
                            }
                            invalid={
                              this.state.contactNameState === "has-danger"
                            }
                          />
                        </FormGroup>
                      </Col>

                      <Col lg="12" >
                        <Label className="form-control-label">Contact's Mobile Number
                        <i className="pl-2 fas fa-info-circle surtitle-gray cursor-pointer " 
                              id="contactPhone"
                          />
                          <UncontrolledTooltip  
                            placement="right" 
                            target="contactPhone" 
                            delay={0}> 
                            Enter your contact's mobile number  
                          </UncontrolledTooltip>

                        </Label>
                        <FormGroup 
                        className={"mt-2 " + this.state.contactPhoneState}
                        >
                          <div className='phone-input '>
                            <PhoneInput
                              placeholder="Your conact's mobile number"
                              value={this.state.contactPhone}
                              defaultCountry="US"
                                onChange={e => this.checkContactPhoneNumber(e)}/>
                          </div>
                        </FormGroup>
                      </Col> 
                      <Col xs={12} className="text-center">
                        <Button style={{fontSize:"1rem"}} disabled={this.state.submitted2 || this.state.isBot || !this.state.botChecked} color={talentMode ? "primary" : "purple"}s ize="lg" block className={talentMode ? " title bg-gradient-livenyte" : " title bg-gradient-purple"}onClick={e => this.handleLaunchSubmit(e)}>
                            {this.state.submitted2 ? 'Launch request sent' : 'Join'}
                        </Button>
                      </Col>
                      */}
                      </Row>
                    </Col>}
                  {this.state.submitted2 &&
                    <Col md="8" xs={11} className="mx-auto text-center" >

                      <Row className="mt-4">
                        <Col lg="12" >
                          <h3 className="mb-0 text-primary ">
                            Thank you for joining the SD Launch! We'll follow up with more details about the SD Launch via email soon.
                          </h3>
                        </Col>
                      </Row>

                    </Col>
                  }
                  <Col md="8" xs={11} className="mx-auto text-center" >
                    <Row className="mt-4">
                      <Col lg="12" >
                        <h3>Disclaimer & Terms</h3>
                        <p>
                          <small className="mb-0">By signing up, you agree to our <a className="text-primary cursor-pointer" onClick={this.toggleLaunchTermsModal}>Launch & Partner Terms.</a>&nbsp;
                            You agree to receive marketing emails and text messages from LiveNyte regarding our launch and partner programs, services, and updates.
                            Message & data rates may apply. Participation is not guaranteed and may be changed or discontinued at any time.
                            You agree to our <a href={config.commonUrl + config.termsLocalPath} target="_blank">Terms of Service,</a> <a href={config.commonUrl + config.privacyLocalPath} target="_blank">Privacy Policy,</a> and to indemnify LiveNyte against any claims related to your participation.
                          </small>
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </section>
            {this.state.promptPartnerWithUsSection &&
              <section className="pt-5 pb-6 bg-darkMode">
                <div className="landingContainer">
                  <Row className="row-grid align-items-center"  >
                    <Col md="8" xs={11} className="mx-auto text-center">
                      <span className={(("display-3 text-center surtitle text-white livenyte-title mb-2 glitch-text glitch-text-animated") + (talentMode !== false ? "special-underline-livenyte" : "special-underline-purple"))}>Partner With Us </span>
                      <h3 className="mt-3 text-center surtitle-light-gray ">
                        {talentMode === true ?
                          "We're partnering with a small group of standout talent & creators to launch LiveNyte in SD. Get featured, booked, and promoted across our platform and events." :
                          "We're partnering with a group of standout businesses & event promoters to launch LiveNyte in SD. Work closely with us, get promoted across our platform and marketing channels."}
                      </h3>
                      {!this.state.partnerWithUsVisible &&
                        <Button style={{ fontSize: "1rem" }} color="white" size="lg" block className="mt-4 title" onClick={e => this.openPartnerWithUsForm(e)}>
                          Apply to be a partner
                        </Button>
                      }
                    </Col>
                    {!this.state.submitted && this.state.partnerWithUsVisible && talentMode &&
                      <div>
                        <Col md="8" xs={11} className="mx-auto" >
                          <Row className='mt-4'>
                            <TalentPartnerForm
                              phoneState={this.state.phoneState}
                              phone={this.state.phone}
                              youtubeState={this.state.youtubeState}
                              youtube={this.state.youtube}
                              descriptionState={this.state.descriptionState}
                              description={this.state.description}
                              whyPartnerState={this.state.whyPartnerState}
                              whyPartner={this.state.whyPartner}

                              submitted={this.state.submitted}
                              isBot={this.state.isBot}
                              botChecked={this.state.botChecked}


                              checkPhoneNumber={this.checkPhoneNumber}
                              checkUrl={this.checkUrl}
                              checkDescription={this.checkDescription}
                              checkWhyPartner={this.checkWhyPartner}
                              handleSubmit={this.handleSubmit}
                            />
                            {/* <Col lg="12">
                        <Label className="form-control-label surtitle-light-gray">Name
                        <i className="pl-2 fas fa-info-circle  surtitle-light-gray cursor-pointer " 
                              id="name"
                          />
                          <UncontrolledTooltip  
                            placement="right" 
                            target="name" 
                            delay={0}> 
                            Enter your name 
                          </UncontrolledTooltip>

                        </Label>
                        <FormGroup 
                        className={"mt-2 " + this.state.nameState}
                        >
                          <Input
                            type="text" 
                            name="name" 
                            disabled
                            value={this.state.name}
                            className='bg-transparent surtitle-light-gray'
                            placeholder="Your name"
                            onBlur={e => this.checkName(e )}
                            onChange={e => this.checkName(e)}
                            valid={
                              this.state.nameState === "has-success"
                            }
                            invalid={
                              this.state.nameState === "has-danger"
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="12" >
                        <Label className="form-control-label surtitle-light-gray">Email
                        <i className="pl-2 fas fa-info-circle surtitle-light-gray cursor-pointer " 
                              id="email"
                          />
                          <UncontrolledTooltip  
                            placement="right" 
                            target="email" 
                            delay={0}> 
                            Enter your email address.  
                          </UncontrolledTooltip>

                        </Label>
                        <FormGroup 
                        className={"mt-2 " + this.state.emailState}
                        >
                          <Input
                            type="email" 
                            name="email" 
                            disabled
                            value={this.state.email}
                            placeholder="Your email"
                            className='bg-transparent surtitle-light-gray autofill-darkMode'
                            onBlur={e => this.checkEmail(e)}
                            onChange={e => this.checkEmail(e)}
                            valid={
                              this.state.emailState === "has-success"
                            }
                            invalid={
                              this.state.emailState === "has-danger"
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="12" >
                        <Label className="form-control-label surtitle-light-gray">Primary Talent
                        <i className="pl-2 fas fa-info-circle surtitle-light-gray cursor-pointer " 
                              id="selectedTrait"
                          />
                          <UncontrolledTooltip  
                            placement="right" 
                            target="selectedTrait" 
                            delay={0}> 
                            Choose the talent that best describes the main thing you do
                          </UncontrolledTooltip>

                        </Label>
                        <FormGroup 
                        className={"mt-2 " + this.state.traitState}
                        >
                          <Select
                            className="react-select primary wrap-cursor-pointer"
                            classNamePrefix="react-select"
                            placeholder="Choose Main Talent"
                            disabled
                            name="selectedTrait"
                            value={this.state.selectedTraitValue}
                            options={traitOptions}
                            onChange={value => this.selectTrait(value) }
                          />
                        </FormGroup>
                      </Col> */}

                            {/* <Col lg="12" >

                        <Label className="form-control-label surtitle-light-gray">Mobile Number
                        <i className="pl-2 fas fa-info-circle surtitle-light-gray cursor-pointer " 
                              id="phone"
                          />
                          <UncontrolledTooltip  
                            placement="right" 
                            target="phone" 
                            delay={0}> 
                            Enter your phone number  
                          </UncontrolledTooltip>

                        </Label>
                        <FormGroup 
                        className={"mt-2 " + this.state.phoneState}
                        >
                          <div className='phone-input-darkMode '>
                            <PhoneInput
                              placeholder="Enter your mobile number"
                              value={this.state.phone}
                              defaultCountry="US"
                                onChange={e => this.checkPhoneNumber(e)}/>
                          </div>
                        </FormGroup>
                      </Col> */}
                            {/* <Col lg="12" >
                        <FormGroup 
                        // className={this.state.nameState}
                        >
                        <Label className="form-control-label surtitle-light-gray">Instagram
                        <i className="pl-2 fas fa-info-circle surtitle-light-gray cursor-pointer " 
                              id="instagram"
                          />
                          <UncontrolledTooltip  
                            placement="right" 
                            target="instagram" 
                            delay={0}> 
                            Enter your instagram handle.  
                          </UncontrolledTooltip>

                        </Label>
                          <Input
                            type="text" 
                            name="instagram" 
                            className='bg-transparent surtitle-light-gray'
                            value={this.state.instagram}
                            placeholder="Your Instagram handle"
                            onBlur={e => this.handleChange(e)}
                            onChange={e => this.handleChange(e)}
                            // valid={
                            //   this.state.nameState === "has-success"
                            // }
                            // invalid={
                            //   this.state.nameState === "has-danger"
                            // }
                          />
                        </FormGroup>
                      </Col> */}
                            {/* <Col lg="12" >
                        <Label className="form-control-label surtitle-light-gray">YouTube Channel Link (optional)
                        <i className="pl-2 fas fa-info-circle surtitle-light-gray cursor-pointer " 
                              id="youtube"
                          />
                          <UncontrolledTooltip  
                            placement="right" 
                            target="youtube" 
                            delay={0}> 
                            Enter your youtube channel link.  
                          </UncontrolledTooltip>

                        </Label>
                        <FormGroup 
                        className={"mt-2 " + this.state.youtubeState}
                        >
                          <Input
                            type="url" 
                            name="youtube" 
                            className='bg-transparent surtitle-light-gray'
                            value={this.state.youtube}
                            placeholder="Your Youtube channel link"
                            onBlur={e => this.checkUrl(e)}
                            onChange={e => this.checkUrl(e)}
                            valid={
                              this.state.youtubeState === "has-success"
                            }
                            invalid={
                              this.state.youtubeState === "has-danger"
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="12" >
                        <Label className="form-control-label surtitle-light-gray">About you
                        <i className="pl-2 fas fa-info-circle surtitle-light-gray cursor-pointer " 
                              id="description"
                          />
                          <UncontrolledTooltip  
                            placement="right" 
                            target="description" 
                            delay={0}> 
                            Write a blurb about yourself. Try to keep it concise. 
                          </UncontrolledTooltip>

                        </Label>
                        <FormGroup className={"mt-2 " + this.state.descriptionState}>
                          <Input 
                            type="textarea" 
                            name="description"
                            className='bg-transparent surtitle-light-gray'
                            value={this.state.description}
                            placeholder="Write a blurb about yourself. Tell us what you want us to know about you, but try to keep it concise.
                            If you have other links showcasing your work on other platforms (ex: Apple Music, Spotify, Soundcloud), you can include them here. "
                            rows="12"
                            cols="80"
                            style={{maxHeight:"300px"}}
                            onChange={e => this.checkDescription(e)}
                            valid={
                              this.state.descriptionState === "has-success"
                            }
                            invalid={
                              this.state.descriptionState === "has-danger"
                            }  />
                        </FormGroup>
                      </Col>

                      <Col lg="12" >
                        <Label className="form-control-label surtitle-light-gray">Why do you want to parner with us? 
                        <i className="pl-2 fas fa-info-circle surtitle-light-gray cursor-pointer " 
                              id="whyPartner"
                          />
                          <UncontrolledTooltip  
                            placement="right" 
                            target="whyPartner" 
                            delay={0}> 
                            Let us know why you want to partner with us.  
                          </UncontrolledTooltip>

                        </Label>
                        <FormGroup className={"mt-2 " + this.state.whyPartnerState}>
                          <Input 
                            type="textarea" 
                            name="whyPartner"
                            value={this.state.whyPartner}
                            className='bg-transparent surtitle-light-gray'
                            placeholder="Why do you want to partner with us?"
                            rows="12"
                            cols="80"
                            style={{maxHeight:"300px"}}
                            onChange={e => this.checkWhyPartner(e)}
                            valid={
                              this.state.whyPartnerState === "has-success"
                            }
                            invalid={
                              this.state.whyPartnerState === "has-danger"
                            }  />
                        </FormGroup>
                      </Col>
                      
                      <Col xs={12} className="text-center">
                      
                        <Button style={{fontSize:"1rem"}} disabled={this.state.submitted || this.state.isBot || !this.state.botChecked} color="white" size="lg" block className="title" onClick={e => this.handleSubmit(e)}>
                            {this.state.submitted ? 'Application sent' : 'Apply'}
                        </Button>
                      </Col> */}
                          </Row>
                        </Col>
                      </div>}

                    {!this.state.submitted && this.state.partnerWithUsVisible && talentMode === false &&
                      <Col md="8" xs={11} className="mx-auto" >
                        <Row className='mt-4'>
                          <BusinessPartnerForm
                            descriptionState={this.state.descriptionState}
                            description={this.state.description}
                            whyPartnerState={this.state.whyPartnerState}
                            whyPartner={this.state.whyPartner}

                            submitted={this.state.submitted}
                            isBot={this.state.isBot}
                            botChecked={this.state.botChecked}


                            checkDescription={this.checkDescription}
                            checkWhyPartner={this.checkWhyPartner}
                            handleSubmit={this.handleSubmit}
                          />
                          {/* <Col lg="12" >
                        <Label className="form-control-label surtitle-light-gray">About you
                        <i className="pl-2 fas fa-info-circle surtitle-light-gray cursor-pointer " 
                              id="description"
                          />
                          <UncontrolledTooltip  
                            placement="right" 
                            target="description" 
                            delay={0}> 
                            Write a blurb about yourself. Try to keep it concise. 
                          </UncontrolledTooltip>

                        </Label>
                        <FormGroup className={"mt-2 " + this.state.descriptionState}>
                          <Input 
                            type="textarea" 
                            name="description"
                            className='bg-transparent surtitle-light-gray'
                            value={this.state.description}
                            placeholder="Write a blurb about yourself. Tell us what you want us to know about you, but try to keep it concise.
                            If you have other links showcasing your work on other platforms (ex: Apple Music, Spotify, Soundcloud), you can include them here. "
                            rows="12"
                            cols="80"
                            style={{maxHeight:"300px"}}
                            onChange={e => this.checkDescription(e)}
                            valid={
                              this.state.descriptionState === "has-success"
                            }
                            invalid={
                              this.state.descriptionState === "has-danger"
                            }  />
                        </FormGroup>
                      </Col>

                      <Col lg="12" >
                        <Label className="form-control-label surtitle-light-gray">Why do you want to parner with us? 
                        <i className="pl-2 fas fa-info-circle surtitle-light-gray cursor-pointer " 
                              id="whyPartner"
                          />
                          <UncontrolledTooltip  
                            placement="right" 
                            target="whyPartner" 
                            delay={0}> 
                            Let us know why you want to partner with us.  
                          </UncontrolledTooltip>

                        </Label>
                        <FormGroup className={"mt-2 " + this.state.whyPartnerState}>
                          <Input 
                            type="textarea" 
                            name="whyPartner"
                            value={this.state.whyPartner}
                            className='bg-transparent surtitle-light-gray'
                            placeholder="Why do you want to partner with us?"
                            rows="12"
                            cols="80"
                            style={{maxHeight:"300px"}}
                            onChange={e => this.checkWhyPartner(e)}
                            valid={
                              this.state.whyPartnerState === "has-success"
                            }
                            invalid={
                              this.state.whyPartnerState === "has-danger"
                            }  />
                        </FormGroup>
                      </Col>
                      <Col xs={12} className="text-center">
                        <Button style={{fontSize:"1rem"}} disabled={this.state.submitted || this.state.isBot || !this.state.botChecked} color="white" size="lg" block className="title" onClick={e => this.handleSubmit(e)}>
                            {this.state.submitted ? 'Application sent' : 'Apply'}
                        </Button>
                      </Col> */}
                        </Row>
                      </Col>}



                    {this.state.submitted &&
                      <Col md="8" xs={11} className="mx-auto text-center" >
                        <Row className='mt-4'>
                          <Col lg="12" >
                            <h3 className="mb-0 text-primary">
                              <hr style={{ borderTop: '1px solid #fff' }} />
                              Thank you for applying to partner with us.
                              {this.state.talentMode ? "Selected talent & creators will be contacted directly for early bookings and launch promotion."
                                : "Selected businesses & event promoters will be contacted directly for collaboration & launch promotion."}
                            </h3>
                            <hr style={{ borderTop: '1px solid #fff' }} />

                            <div className='mt-6'>
                              <span className={(("display-3 text-center surtitle text-white livenyte-title  mb-2 glitch-text glitch-text-animated") + (talentMode !== false ? "special-underline-livenyte" : "special-underline-purple"))}>Ready to get Started?</span>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col className="mt-4 mx-auto" xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Button style={{ fontSize: "1rem" }} color="primary" block className={" bg-gradient-livenyte"} size="lg" onClick={() => this.handleButtonClick("register")}>
                              Sign up on web
                            </Button>
                          </Col>
                        </Row>
                        <Row className="mt-4">
                          <Col xs={6} className="mr-auto">
                            <a href="https://itunes.apple.com/us/app/livenyte/id1378430467?mt=8"
                              className={"btn-app"} style={{ height: "51px", marginRight: "0px", paddingRight: "0px" }}>
                              <img src={appStore} alt="App Store Button" />
                            </a>

                          </Col>
                          <Col xs={6} className="ml-auto">
                            <a href="https://play.google.com/store/apps/details?id=com.kunal.livenyte.livenyte"
                              className={"btn-app"} style={{ float: "right", marginRight: "0px", paddingRight: "0px" }}>
                              <img src={playStore} alt="Play Store Button" />
                            </a>
                          </Col>

                        </Row>
                      </Col>
                    }
                    <Col md="8" xs={11} className="mx-auto text-center" >
                      <Row className="mt-4">
                        <Col lg="12" >
                          <h3 className="text-white">Disclaimer & Terms</h3>
                          <p className="text-lighter">
                            <small className="mb-0">By signing up, you agree to our <a className="text-primary cursor-pointer" onClick={this.toggleLaunchTermsModal}>Launch & Partner Terms.</a>&nbsp;
                              You agree to receive marketing emails and text messages from LiveNyte regarding our launch and partner programs, services, and updates.
                              Message & data rates may apply. Participation is not guaranteed and may be changed or discontinued at any time.
                              You agree to our <a href={config.commonUrl + config.termsLocalPath} target="_blank">Terms of Service,</a> <a href={config.commonUrl + config.privacyLocalPath} target="_blank">Privacy Policy,</a> and to indemnify LiveNyte against any claims related to your participation.
                            </small>
                          </p>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>
              </section>
            }
            {this.state.submitted2 && !this.state.submitted &&
              <section className="pt-5 pb-6 bg-secondary">
                <div className="landingContainer">
                  <Row className="row-grid align-items-center"  >
                    <Col md="8" xs={11} className="mx-auto">
                      <span className=" display-3 text-center surtitle text-default livenyte-title mb-2">Ready to get started?</span>
                    </Col>
                    {this.state.submitted2 &&
                      <Col md="8" xs={11} className="mx-auto text-center" >
                        <Row>
                          <Col className="mt-4 mx-auto" xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Button style={{ fontSize: "1rem" }} color="primary" block className={" bg-gradient-livenyte"} size="lg" onClick={() => this.handleButtonClick("register")}>
                              Sign up on web
                            </Button>
                          </Col>
                        </Row>
                        <Row className="mt-4">
                          <Col xs={6} className="mr-auto">
                            <a href="https://itunes.apple.com/us/app/livenyte/id1378430467?mt=8"
                              className={"btn-app"} style={{ height: "51px", marginRight: "0px", paddingRight: "0px" }}>
                              <img src={appStore} alt="App Store Button" />
                            </a>

                          </Col>
                          <Col xs={6} className="ml-auto">
                            <a href="https://play.google.com/store/apps/details?id=com.kunal.livenyte.livenyte"
                              className={"btn-app"} style={{ float: "right", marginRight: "0px", paddingRight: "0px" }}>
                              <img src={playStore} alt="Play Store Button" />
                            </a>
                          </Col>


                        </Row>
                      </Col>
                    }
                  </Row>
                </div>
              </section>
            }
          </div>}
        <Row>
          <Modal
            isOpen={this.state.launchTermsModal}
            toggle={this.toggleLaunchTermsModal}
            className="modal-notice text-center"
            size="lg"
            fade={false}
          >
            <LiveNyteLaunchPartnerTerms toggle={this.toggleLaunchTermsModal} />
          </Modal>
        </Row>
        <AuthFooter />
      </div>

    );
  }
}

//export default Dashboard;
function mapStateToProps(state) {
  const { memberInfo, eventsData, notificationsData, messagesData, screenSizeData, authentication, traitData } = state;
  const { fetchingEvents, events, sbTraitStatus } = eventsData;
  const { info } = memberInfo;
  const { notifications, fetchingNotifications } = notificationsData;
  const { new_messages } = messagesData;
  const { is_xxs, is_xs, is_sm, is_md, is_lg, is_xl, is_xxl, updateScreenSizeRequest } = screenSizeData;
  const { loggingIn, loggedIn, } = authentication
  const { fetchingTraits, spTraits, spSubTraits, busTraits } = traitData;


  console.log("Dashboard: mapStateToProps");
  console.log(events, notifications)
  return {
    info,
    fetchingEvents,
    events,
    sbTraitStatus,
    notifications,
    new_messages,
    fetchingNotifications,
    is_xxs, is_xs, is_sm, is_md, is_lg, is_xl, is_xxl, updateScreenSizeRequest,
    loggingIn, loggedIn,
    fetchingTraits, spTraits, spSubTraits, busTraits

  };
}

const connectedSDLandingPage = connect(mapStateToProps)(SDLandingPage);
export { connectedSDLandingPage as SDLandingPage };

